module.exports = __webpack_public_path__ + "static/media/Stillion_figure.d6c5721b.jpg";